import { createFileRoute, redirect } from '@tanstack/react-router';

/** Merged into the Templates hub as the "Instagram" tab. Redirect keeps old
 *  links, bookmarks, and the builder pages' back-buttons working. */
export const Route = createFileRoute('/vendor/instagram/templates/')({
  beforeLoad: () => {
    throw redirect({ to: '/vendor/templates', search: { channel: 'instagram' } });
  },
});
